// export const branchCode = process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? "TI" : "TU";
export const branchCode = process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? "IE" : "UK";